/**
 * 请求接口
 */

import http from './http'
import qs from 'qs'

export const getUserInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = true, showToast = false } = {}) => {
  const url = `/user/userId/${params.userId}`
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

// 用户获取商家地图列表接口
export const getShopInfo = ({
  pageInfo = {},
  params = {},
  headers = {},
  finalFunc = null,
  showLoading = false,
  showToast = false
} = {}) => {
  const url = `/store/redmap/${pageInfo.page}/${pageInfo.pageSize}?v=${Date.now().toString() + Math.random().toString()}`
  return http.post({ url, params, headers, finalFunc, showLoading, showToast })
}

// 获取重叠信息点列表
export const getOverLappingShopInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  return http.get({ url: `/store/redmap/adjacentpoint?id=${params.id}` })
}

// 详情页接口
export const getShopDetail = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = `/store/redmap/detail?v=${Date.now().toString() + Math.random().toString()}`
  return http.post({ url, params, headers, finalFunc, showLoading, showToast })
}

// 活动详情
export const getActivityInfo = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = `/activity/redmap/detail?id=${params.id}`
  params = null
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

// 搜索接口
export const getSearchResult = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = '/store/redmap/search'
  return http.post({ url, params, headers, finalFunc, showLoading, showToast })
}

// 查询开门页状态
export const getOpenPageResult = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = `/openpage/redmap/detail?activityId=${params.id}`
  params = null
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

// 打卡相关
export const getMyClockIn = ({ activityId }) => {
  return http.post({ url: '/clockIn/redmap/my/clock/in', params: qs.stringify({ activityId }) })
}

export const getStoreClockIn = ({ storeId }) => {
  return http.post({ url: '/clockIn/redmap/clock/in', params: { storeId } })
}

export const getBase64Image = url => {
  return http.post({ url: '/file/url/to/base64', params: qs.stringify({ url }) })
}

export const getRecordById = id => {
  return http.post({ url: '/clockIn/redmap/my/clock/in/id', params: qs.stringify({ id }) })
}

export const summarize = params => {
  return http.post({ url: '/store/redmap/summarize', params, showToast: false })
}

// 活动数量统计
export const activityVisitor = params => {
  const url = `/activity/visitor/view?activityId=${params.activityId}`
  params = null
  return http.post({ url, params, showToast: false })
}

export const detailPageVisitor = params => {
  const url = `/store/visitor/view?storeId=${params.id}`
  params = null
  return http.post({ url, params, showToast: false })
}

// 支持筛选城市 区域 地铁线路
export const getShopList = params => {
  const url = '/store/redmap/cityStore/page'
  return http.post({ url, params, showToast: false })
}

/** 根据城市获取信息点 */
export const getRedRouteByCity = params => {
  const url = '/store/redmap/cityStore/page'
  return http.post({ url, params, showToast: false })
}
/** 我的路线 */
export const myRedRoutes = ({ params = {} } = {}) => {
  const url = `/redRoute/myRedRoutes?activityId=${params.activityId}`
  params = null
  return http.get({ url, params, showLoading: false, showToast: false })
}
/** 根据路线id获取路线详情 */
export const getRedRouteDetailById = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = `/redRoute/get?id=${params.id}`
  params = null
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}
/** 定制路线 */
export const createRedRoute = params => {
  const url = '/redRoute/create'
  return http.post({ url, params, showToast: false })
}
/** 上传海报 */
export const uploadPosterImg = params => {
  console.log(params)
  const url = '/redRoute/uploadPosted'
  const headers = {
    'Content-Type': 'multipart/form-data'
  }
  return http.post({ url, params, showToast: false, headers, showLoading: false })
}
/** 根据路线id获取路线详情-扫码进来页面使用 */
export const getRedRouteDetailByIdScan = ({ params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false } = {}) => {
  const url = `/redRoute/getByRedRouteId?id=${params.id}`
  params = null
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}
/** 签到 */
export const signIn = (params) => {
  const url = '/signIn/signIn'
  const headers = {
    'Content-Type': 'application/json'
  }
  return http.post({ url, params, headers, showLoading: false, showToast: false, interceptError: false })
}
/** 点赞 */
export const getLikeNum = (params = {}) => {
  const url = `/storeLike/getNum?storeId=${params.storeId}`
  params = null
  return http.get({ url, params, headers: {}, finalFunc: null, showLoading: false, showToast: false, interceptError: false })
}
export const like = (params = {}) => {
  const url = '/storeLike/like'
  const headers = {
    'Content-Type': 'application/json'
  }
  return http.post({ url, params, headers, showLoading: false, showToast: false, interceptError: false })
}

export const getHasLike = (params = {}) => {
  const url = `/storeLike/hasLike?storeId=${params.storeId}`
  params = null
  return http.get({ url, params, headers: {}, finalFunc: null, showLoading: false, showToast: false, interceptError: false })
}
// 获取城市和区
export const getLocationByPid = (pid) => {
  const url = `https://toolsapi.nfapp.southcn.com/location/getLocationByPid?pid=${pid}`
  return http.get({ url, params: null, headers: {}, finalFunc: null, showLoading: false, showToast: false, interceptError: false })
}
// 根据城市编码获取有信息点的区
export const getStoreRegionByCity = (params) => {
  const url = '/store/getStoreRegionByCity'
  return http.post({ url, params, headers: {}, finalFunc: null, showLoading: false, showToast: false, interceptError: false })
}
// 根据城市编码获取有信息点的线路
export const getStoreSubwayByCity = (params) => {
  const url = '/store/getStoreSubwayByCity'
  return http.post({ url, params, headers: {}, finalFunc: null, showLoading: false, showToast: false, interceptError: false })
}
